<template>
  <div class="login">
    <div class="md-layout text-center">
      <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
        <login-card header-color="blue">
          <h4 slot="title" class="title">{{$t('login.title')}}</h4>
          
          <md-field class="md-form-group" slot="inputs" :class="{'md-error': $v.userModel.username.$error && $v.userModel.username.$invalid, 'md-valid': !$v.userModel.username.$error && !$v.userModel.username.$invalid}">
            <md-icon>face</md-icon>
            <label>{{$t('login.username')}}</label>
            <md-input v-model.trim="$v.userModel.username.$model"></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="$v.userModel.username.$error && $v.userModel.username.$invalid">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="!$v.userModel.username.$error && !$v.userModel.username.$invalid">done</md-icon>
            </slide-y-down-transition>
          </md-field>
          
          <md-field class="md-form-group" slot="inputs" :class="{'md-error': $v.userModel.password.$error && $v.userModel.password.$invalid, 'md-valid': !$v.userModel.password.$error && !$v.userModel.password.$invalid}">
            <md-icon>lock_outline</md-icon>
            <label>{{$t('login.password')}}</label>
            <md-input class="has-error" v-model="$v.userModel.password.$model" type="password"></md-input>
          </md-field>
          
          <md-button slot="footer" class="md-simple md-info md-lg" @click.prevent="login">
            {{$t('login.login')}}
          </md-button>
        </login-card>
      </div>
    </div>
    <notifications></notifications>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import persistentData from "@/plugins/persistentData";
import { required } from 'vuelidate/lib/validators';
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    LoginCard,
    SlideYDownTransition
  },
  data() {
    return {
      userModel: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    async login() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const authenticate = await this.$store.dispatch('authenticate', this.userModel)
        if (authenticate) {
          persistentData.setData('fullName', `${authenticate.data.firstName} ${authenticate.data.lastName}`)
          persistentData.setData('token', authenticate.data.token)
          persistentData.setData('tokenExpiration', authenticate.data.tokenExpiration)
          persistentData.setData('admin', authenticate.data.roles.includes("Admin"), true)
          persistentData.setData('showController', authenticate.data.roles.includes("ShowController"), true)
          this.$router.push('/list/games')
        } else {
          this.$notify({
            message: this.$t(`notifications.error`),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
        }
      } 
    }
  },
  validations: {
    userModel: {
      username: {
        required
      },
      password: {
        required
      }
    }
  }
};
</script>

<style>
.login {
  padding-top: 24px;
}
</style>
